const announceItems = document.querySelectorAll('.announcement-bar__ada-disclosure');

if (
  announceItems.length === 1 &&
  announceItems[0].textContent.toLowerCase().includes('you need assistance')
) {
  announceItems[0].classList.add('sr-only');
  announceItems[0].setAttribute('tabindex', '0');
  // remove padding to eliminate empty padding space
  announceItems[0].parentNode.parentNode.style.padding = '0';
} else {
  for (let item of announceItems) {
    if (item.textContent.toLowerCase().includes('you need assistance')) {
      item.classList.add('sr-only');
      item.classList.remove('relative');
      item.classList.add('absolute');
      item.setAttribute('tabindex', '0');
    }
  }
}
